import { PrivateInterceptor } from '../../../interceptors/PrivateInterceptor'
import { PublicInterceptor } from "../../../interceptors/PublicInterceptor";

// OBTENER ACTIVOS FIJOS
export const getInformacionEmpresa = async () => {
    const response = await PrivateInterceptor('Base/Global/InformacionEmpresa', 'GET');
    return response;
}

export const getInformacionEmpresaPublic = async (Token) => {
    const response = await PublicInterceptor('Base/Global/InformacionEmpresa/token', 'POST', {}, Token);
    return response;
}

// GUARDAR ACTIVOS FIJOS
export const EditarInformacionEmpresa = (Datos) => {
    const respuesta = PrivateInterceptor("Base/Global/InformacionEmpresa/EditarInformacionEmpresa", "POST", {Datos});
    return respuesta;
  };
  
